import { render, staticRenderFns } from "./serve-table.vue?vue&type=template&id=5be08bca&scoped=true&"
import script from "./serve-table.vue?vue&type=script&lang=js&"
export * from "./serve-table.vue?vue&type=script&lang=js&"
import style0 from "./serve-table.vue?vue&type=style&index=0&id=5be08bca&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be08bca",
  null
  
)

export default component.exports